/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 14:46:43
 */
import { defineStore } from 'pinia';
import { ref } from 'vue';

const globalView = defineStore('globalView',()=>{
    const lang = ref('') // 国际化语言

    const changeLang = (val)=>{
        lang.value = val
    }

    return {
        lang,
        changeLang
    }
})

export {
    globalView
}